// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomRadioButton_root__1UsUR","containerInput":"CustomRadioButton_containerInput__dBD10","checkmark":"CustomRadioButton_checkmark__3Ann8"};